<template>
  <div class="column gap-4">
    <div v-for="(options, type) in itemOptions" :key="type">
      <h4 class="label mv-0">{{ $t(`objectNames.${type}`) }}</h4>
      <div class="line gap-2">
        <chart-data-button
          class="w-full"
          :chart-uid="chartUid"
          :item-type="(type as ConfigurableType)"
          :item-id="selectedItem && selectedItem?.type == type ? selectedItem.id : -1"
        >
          <template #item>
            <input-dropdown
              :class="{
                'evaluation-data-sidebar__unselectedinput':
                  selectedItem && selectedItem?.type != type
              }"
              class="w-full"
              :searchable="true"
              :options="options"
              :value="selectedItem?.type == type ? selectedItem : null"
              :item-key="(i) => `${i.type}_${i.id}`"
              @update:value="emit('selectItem', $event)"
            >
              <template #default="{ item }">
                {{ item?.title ?? item }}
              </template>
            </input-dropdown>
          </template>
        </chart-data-button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import ChartDataButton from '../charts/ChartBuilderDataButton.vue';
import InputDropdown from '@core/input/InputDropdown.vue';
import type { Uid } from '@/helpers/utility/Id';
import type { ConfigurableType, SelectableChartItem } from "@editor/items/charts/ChartItem";

defineProps<{
  chartUid: Uid<"evaluation" | "chart">;
  itemOptions: Record<ConfigurableType, SelectableChartItem[]>;
  selectedItem: SelectableChartItem | null;
}>();

const emit = defineEmits<{
  (e: 'selectItem', item: SelectableChartItem | null): void;
}>();
</script>